import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookInfoPodcast from '@/components/ui/book-info-podcast/BookInfoPodcast';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import PodcastsDetailItem from './PodcastsDetailItem';
// import ReviewsList from '@/components/ui/reviews-list/ReviewsList';
// import FormReview from '@/components/ui/form-review/FormReview';
import { getAuthorFullName } from '@/helpers/helpers';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IPodcastsDetailData } from '@/interfaces/podcastsDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import styles from './PodcastsDetail.module.scss';

interface IBookDetailPage {
  book: IPodcastsDetailData;
  reviews: IReviews;
  isPodcastPage?: boolean;
}

const PodcastsDetail: FC<IBookDetailPage> = ({ book, reviews, isPodcastPage }) => {
  const isPodcastsFree = book.allow_full_free === 1;

  const { first_name, middle_name, last_name } = book.authors[0];

  const authorFullName = getAuthorFullName(first_name, middle_name, last_name);

  const SEO_TITLE = `Слушать онлайн подкаст ${book.title} онлайн бесплатно`;
  const SEO_DESCRIPTION = `Подкаст ${book.title} слушать онлайн. Все выпуски аудиоподкаста на одной странице абсолютно бесплатно. Можно скачать и слушать офлайн`;

  const SEO_CANONICAL = useGetUrlPath();

  const SEO_COVER = `https://fantasy-worlds.ru/covers/${book.external_id}.jpg`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} cover={SEO_COVER}>
      <Breadcrumbs firstPageName="Подкасты" firstPageAlias="/lib/podcasts/" secondPageName={authorFullName} thirdPageName={book.title} />

      <BookInfoPodcast book={book as any} isPodcastsFree={isPodcastsFree} />

      <div className={styles.podcast}>
        <h2 className={styles.h2}>Cписок подкастов</h2>
      </div>

      <ul className={styles.podcastsList}>
        {book.items.length > 0 &&
          book.items.map((item, index) => (
            <PodcastsDetailItem externail_id={item.external_id} description={item.description} podcastNumber={book.items.length - index} title={item.title} duration={item.duration} created_at={item.created_at} rating={item.rating} key={item.id} />
          ))}
      </ul>

      {/* {reviews.total_count > 0 && (
        <>
          <div className={styles.book__title}>
            <h2 className={styles.h2}>Отзывы</h2>
          </div>
          <ReviewsList reviews={reviews} />
        </>
      )} */}

      {/* <div id="bookReviewForm">
        <h2 className={styles.h2}>Оcтавить отзыв</h2>
        <FormReview bookId={book.id} bookAlias={book.alias} />
      </div> */}
    </Layout>
  );
};

export default PodcastsDetail;
